import { render, staticRenderFns } from "./DownRecord.vue?vue&type=template&id=39da316e&"
import script from "./DownRecord.vue?vue&type=script&lang=js&"
export * from "./DownRecord.vue?vue&type=script&lang=js&"
import style0 from "./DownRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports